export default {
  filter: (record, fields) => {
    let data = {};
    for (var i = 0; i < fields.length; i++) {
      const field = fields[i];
      data[field] = record[field];
    }
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/utils/fieldFilter.js